/**
 * @JSdoc Object
 * @name constants.js
 * @description Global constants for entire application
 *
 */

export default {
    
   
    general: {
        rows_per_page: 20,
    },

    icon: {
        chart: "https://i.pinimg.com/originals/a5/3b/cd/a53bcde225dd2c34a1d1d721874d1d22.png",
        download: 'https://i.redd.it/t4f6ysfremu11.png',
        msg: 'https://cdn2.iconfinder.com/data/icons/amazon-aws-stencils/100/Database_copy_DynamoDB-512.png'
    }

}
